import {
    isAssetRetrievalDraftResponse,
    isAssetRetrievalOrder,
    isAssetRetrievalQuotation,
} from '@repo/types/asset-retrieval';

import { getServiceEndpoint } from '@/api/helpers.api';
import { fetcher } from '@/utils/fetch.utils';
import { getAppConfig } from '@/utils/window.utils';

import { AssetRetrievalError } from './asset-retrieval-error.api';

export const retrieveOrder = async (orderNo: string) => {
    const config = getAppConfig();
    const url = `${getServiceEndpoint(config.api.services.classicSalja, 'orderRetrieval')}/get-order/${orderNo}`;
    const response = await fetcher(url);
    const data = await response.json();

    return isAssetRetrievalOrder(data) ? data : Promise.reject(new AssetRetrievalError());
};

export const retrieveDraft = async (draftId: string) => {
    const config = getAppConfig();

    const url = config.feature.draftV2Service?.enable
        ? `${getServiceEndpoint(config.api.services.orderTaking, 'draftRetrieval')}/${draftId}`
        : `${getServiceEndpoint(config.api.services.classicSalja, 'draftRetrieval')}/${draftId}`;

    const response = await fetcher(url);
    const data = await response.json();

    if (!isAssetRetrievalDraftResponse(data, draftId)) {
        throw new AssetRetrievalError();
    }

    const draft = data[draftId];

    if (!draft) {
        throw new AssetRetrievalError(404);
    }

    return draft;
};

export const retrieveQuotation = async (quotationId: string) => {
    const config = getAppConfig();
    const url = `${getServiceEndpoint(config.api.services.orderTaking, 'quotationRetrieval')}/${quotationId}`;
    const response = await fetcher(url);
    const data = await response.json();

    return isAssetRetrievalQuotation(data) ? data : Promise.reject(new AssetRetrievalError());
};
